import * as React from "react";
import { commonClientResx } from "~/resxDist/commonClientResx";
import { ButtonTrash } from "~/sharedComponents/buttons";
import { Highlighter } from "~/sharedComponents/highlighter";
import { Box, Flex } from "~/sharedComponents/layout";
import { VirtListRowProps } from "~/sharedComponents/list/BaseList";
import { RowCheckMark } from "~/sharedComponents/list/ListRowDefault";
import { getRowStyle } from "~/sharedComponents/listRows";
import * as listStyles from "./VirtList.less";

interface ListDeleteDefaultRowProps {
    onDelete?: F<void>;
}

export const ListDeleteDefaultRow = <TItem extends {}>(props: VirtListRowProps<TItem> & ListDeleteDefaultRowProps) => {
    const { item, isFocused, textForHighlight, selected, onDelete, getItemLabel } = props;

    return (
        <div className={getRowStyle(props)}>
            <Highlighter
                showTitle={true}
                className={listStyles.label}
                text={getItemLabel(item)}
                textForHighlight={textForHighlight}
            />
            <Flex marginLeft={"auto"} alignItems={"center"} alignSelf={"stretch"}>
                {isFocused && (
                    <div className={listStyles.delete_btn}>
                        <ButtonTrash action={onDelete} stopPropagation={true} title={commonClientResx.Delete} />
                    </div>
                )}
                {selected && isFocused && <Separator />}
                <RowCheckMark selected={selected} />
            </Flex>
        </div>
    );
};

const Separator: React.FC = () => (
    <Box
        borderRight={1}
        alignSelf={"stretch"}
        margin={"0 16"} // 16 - equals to list row padding
    />
);
